<template>
  <v-container fluid>
    <v-breadcrumbs :items="breadItems" class="breadcrumb mx-16">
    </v-breadcrumbs>
    <!-- <v-card> -->
    <v-row dense class="mx-16 justify-center">
      <!-- TCGA Project -->
      <v-col sm="12" md="12" lg="12" cols="12">
        <v-card-title class="font-weight-bold grey lighten-2">
          Available TCGA project files for MRAS software.
        </v-card-title>
        <div class="text-start my-2">
          <v-simple-table dense class="data-table-style">
            <thead>
              <tr>
                <th class="font-weight-bold">Project ID</th>
                <th class="font-weight-bold">Project Name</th>
                <th class="font-weight-bold">Primary Site</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_ACC.zip')">
                    <span class="font-weight-bold">TCGA-ACC</span>
                  </a>
                  <!-- <a :href="getDownloadUrl('TCGA_network/TCGA_ACC.zip')" download>
                    <span class="font-weight-bold">TCGA-ACC</span>
                  </a> -->
                </td>
                <td>Adrenocortical Carcinoma</td>
                <td>Adrenal Gland</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_BLCA.zip')">
                    <span class="font-weight-bold">TCGA-BLCA</span>
                  </a>
                </td>
                <td>Bladder Urothelial Carcinoma</td>
                <td>Bladder</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_BRCA.zip')">
                    <span class="font-weight-bold">TCGA-BRCA</span>
                  </a>
                </td>
                <td>Breast Invasive Carcinoma</td>
                <td>Breast</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_CESC.zip')">
                    <span class="font-weight-bold">TCGA-CESC</span>
                  </a>
                </td>
                <td>Cervical Squamous Cell Carcinoma and Endocervical Adenocarcinoma</td>
                <td>Cervix</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_CHOL.zip')">
                    <span class="font-weight-bold">TCGA-CHOL</span>
                  </a>
                </td>
                <td>Cholangiocarcinoma</td>
                <td>Liver</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_COAD.zip')">
                    <span class="font-weight-bold">TCGA-COAD</span>
                  </a>
                </td>
                <td>Colon Adenocarcinoma</td>
                <td>Colon</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_DLBC.zip')">
                    <span class="font-weight-bold">TCGA-DLBC</span>
                  </a>
                </td>
                <td>Lymphoid Neoplasm Diffuse Large B-cell Lymphoma</td>
                <td>Lymph nodes</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_ESCA.zip')">
                    <span class="font-weight-bold">TCGA-ESCA</span>
                  </a>
                </td>
                <td>Esophageal Carcinoma</td>
                <td>Esophagus</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_GBM.zip')">
                    <span class="font-weight-bold">TCGA-GBM</span>
                  </a>
                </td>
                <td>Glioblastoma Multiforme</td>
                <td>Brain</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_HNSC.zip')">
                    <span class="font-weight-bold">TCGA-HNSC</span>
                  </a>
                </td>
                <td>Head and Neck Squamous Cell Carcinoma</td>
                <td>Head and Neck</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_KICH.zip')">
                    <span class="font-weight-bold">TCGA-KICH</span>
                  </a>
                </td>
                <td>Kidney Chromophobe</td>
                <td>Kidney</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_KIRC.zip')">
                    <span class="font-weight-bold">TCGA-KIRC</span>
                  </a>
                </td>
                <td>Kidney Renal Clear Cell Carcinoma</td>
                <td>Kidney</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_KIRP.zip')">
                    <span class="font-weight-bold">TCGA-KIRP</span>
                  </a>
                </td>
                <td>Kidney Renal Papillary Cell Carcinoma</td>
                <td>Kidney</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_LGG.zip')">
                    <span class="font-weight-bold">TCGA-LGG</span>
                  </a>
                </td>
                <td>Brain Lower Grade Glioma</td>
                <td>Brain</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_LIHC.zip')">
                    <span class="font-weight-bold">TCGA-LIHC</span>
                  </a>
                </td>
                <td>Liver Hepatocellular Carcinoma</td>
                <td>Liver</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_LUAD.zip')">
                    <span class="font-weight-bold">TCGA-LUAD</span>
                  </a>
                </td>
                <td>Lung Adenocarcinoma</td>
                <td>Lung</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_LUSC.zip')">
                    <span class="font-weight-bold">TCGA-LUSC</span>
                  </a>
                </td>
                <td>Lung Squamous Cell Carcinoma</td>
                <td>Lung</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_MESO.zip')">
                    <span class="font-weight-bold">TCGA-MESO</span>
                  </a>
                </td>
                <td>Mesothelioma</td>
                <td>Heart</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_OV.zip')">
                    <span class="font-weight-bold">TCGA-OV</span>
                  </a>
                </td>
                <td>Ovarian Serous Cystadenocarcinoma</td>
                <td>Ovary</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_PAAD.zip')">
                    <span class="font-weight-bold">TCGA-PAAD</span>
                  </a>
                </td>
                <td>Pancreatic Adenocarcinoma</td>
                <td>Pancreas</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_PCPG.zip')">
                    <span class="font-weight-bold">TCGA-PCPG</span>
                  </a>
                </td>
                <td>Pheochromocytoma and Paraganglioma</td>
                <td>Adrenal Gland</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_PRAD.zip')">
                    <span class="font-weight-bold">TCGA-PRAD</span>
                  </a>
                </td>
                <td>Prostate Adenocarcinoma</td>
                <td>Prostate</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_READ.zip')">
                    <span class="font-weight-bold">TCGA-READ</span>
                  </a>
                </td>
                <td>Rectum Adenocarcinoma</td>
                <td>Colon</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_SARC.zip')">
                    <span class="font-weight-bold">TCGA-SARC</span>
                  </a>
                </td>
                <td>Sarcoma</td>
                <td>Soft Tissue</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_SKCM.zip')">
                    <span class="font-weight-bold">TCGA-SKCM</span>
                  </a>
                </td>
                <td>Skin Cutaneous Melanoma</td>
                <td>Skin</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_STAD.zip')">
                    <span class="font-weight-bold">TCGA-STAD</span>
                  </a>
                </td>
                <td>Stomach Adenocarcinoma</td>
                <td>Stomach</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_TGCT.zip')">
                    <span class="font-weight-bold">TCGA-TGCT</span>
                  </a>
                </td>
                <td>Testicular Germ Cell Tumors</td>
                <td>Testis</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_THCA.zip')">
                    <span class="font-weight-bold">TCGA-THCA</span>
                  </a>
                </td>
                <td>Thyroid Carcinoma</td>
                <td>Thyroid</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_THYM.zip')">
                    <span class="font-weight-bold">TCGA-THYM</span>
                  </a>
                </td>
                <td>Thymoma</td>
                <td>Thymus</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_UCEC.zip')">
                    <span class="font-weight-bold">TCGA-UCEC</span>
                  </a>
                </td>
                <td>Uterine Corpus Endometrial Carcinoma</td>
                <td>Uterus</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_UCS.zip')">
                    <span class="font-weight-bold">TCGA-UCS</span>
                  </a>
                </td>
                <td>Uterine Carcinosarcoma</td>
                <td>Uterus</td>
              </tr>
              <tr>
                <td>
                  <a @click="getDownloadUrl('TCGA_network/TCGA_UVM.zip')">
                    <span class="font-weight-bold">TCGA-UVM</span>
                  </a>
                </td>
                <td>Uveal Melanoma</td>
                <td>Eye</td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'DownloadZL',
  data() {
    return {
      breadItems: [
        {
          text: 'Home',
          disabled: false,
          href: '/ascancer/home',
        },
        {
          text: 'Download',
          disabled: true,
        },
        {
          text: 'MRAS',
          disabled: true,
        },
      ],
    }
  },
  methods: {
    getDownloadUrl(fileName) {
      const downloadUrl = `https://ngdc.cncb.ac.cn/ascancer/api/download/files/?name=${fileName}`;

      // 创建一个隐藏的 <a> 元素
      const link = document.createElement('a');
      link.href = downloadUrl;

      // 设置 download 属性防止页面跳转
      link.setAttribute('download', fileName);

      // 将 <a> 元素添加到文档并模拟点击
      document.body.appendChild(link);
      link.click();

      // 移除 <a> 元素
      document.body.removeChild(link);
    },
  },
}
</script>

<style scoped lang="sass">
a
  text-decoration: none
  color: #2196F3

a:hover
  text-decoration: underline

.v-data-table ::v-deep th
  font-size: 0.87rem !important
.v-data-table ::v-deep td
  font-size: 0.875rem !important

.v-btn
  text-transform: none
  letter-spacing: 0em
  font-size: 0.875rem

.v-card__title
  line-height: 0.5rem

.v-tab
  text-transform: none

.data-table-style
  border: thin solid rgba(0, 0, 0, 0.12)

.v-item-group
  flex: 0 1 auto
  position: relative
  display: inline-flex
  flex-wrap: wrap
  max-width: 100%
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)

.breadcrumb
  line-height: 1
  display: inline-block
  margin: 0 0
  vertical-align: middle
  padding: 8px 15px
  margin-top: -5px
  margin-bottom: 10px
  list-style: none
  background-color: #f5f5f5
  border-radius: 4px
</style>